import { Box, styled } from '@mui/material';

export const CardStyleWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '776px',
  margin: 'auto',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '16px',

  [theme.breakpoints.down('sm')]: {
    maxWidth: 'initial',
  },
}));

export const IconWrapper = styled(Box)(() => ({
  width: '216px',
  height: '120px',
  margin: '0 auto 0px',

  svg: {
    width: '100%',
    height: '100%',
  },
}));

export const CardItemStyled = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.case.neutral.n200}`,
  borderRadius: '8px',
  cursor: 'pointer',
  backgroundColor: theme.palette.case.background,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '12px 24px 24px 24px',
  width: '264px',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.case.neutral.n75,
  },

  '&:active': {
    border: `1px solid ${theme.palette.case.blue.b400}`,
    backgroundColor: theme.palette.case.neutral.n100,
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
